import { ref, deleteObject } from "firebase/storage";
import { storage } from "../../../../firebase";

/**
 * Deletes a file from Firebase Storage given its storage path.
 * @param {string} storagePath - The full path of the file in storage to delete.
 * @returns {Promise<void>}
 */
export async function deleteFileFromStorage(storagePath) {
  if (!storagePath) {
    throw new Error("Storage path is required to delete a file.");
  }
  const fileRef = ref(storage, storagePath);
  await deleteObject(fileRef);
}
